module.exports = __webpack_public_path__ + "static/media/DDIGIM.c1be6ba8.svg";